import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { timesheetApi, Util} from "../../services";
import { leaveService } from '../../services/extensions';

const ExpensesReview = ({ userData }) => {
  const [emExpensesList, setemExpensesList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [usersBySuperior, setUsersBySuperior] = useState([]);

  useEffect(() => {
    fetchEmpLeave(userData.id);
    fetchUsersBySuperior();
    setSelectedUser({
      id: userData.id,
      name: Util.titleCase(userData.firstName + " " + userData.lastName),
    });
  }, []);

  const fetchEmpLeave = (param = {}) => {
    leaveService.getAllLeaveByUserId(param).then((resp) => {
      try {
        setemExpensesList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const fetchUsersBySuperior = (param = {}) => {
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (usersBySuperior[index] = {
            id: user.id,
            name:
              user.firstName.charAt(0).toUpperCase() +
              user.firstName.slice(1) +
              " " +
              user.lastName.charAt(0).toUpperCase() +
              user.lastName.slice(1),
          })
        );
      } catch (error) {
        // Error handle
      }
    });
  };

  const userOptionTemplate = (data) => {
    return (
      <div className="user-item grid">
        <div className="icon">
          {data.icon == null ? (
            <span>{data.name.substr(0, 1)}</span>
          ) : (
            <img src={data.icon} />
          )}
        </div>
        <div className="label col">{data.name}</div>
      </div>
    );
  };

  const selectedUserTemplate = (data, props) => {
    if (data) {
      return (
        <div className="user-item user-item-value grid">
          <div className="icon">
            {data.icon == null ? (
              <span>{data.name.substr(0, 1)}</span>
            ) : (
              <img src={data.icon} />
            )}
          </div>
          <div className="label col p-2">{data.name}</div>
        </div>
      );
    }
  };

  const changeUser = (op) => {
    const curIndex = usersBySuperior.indexOf(selectedUser);
    let result = {};
    if (op == 1) {
      // Next Action
      if (curIndex < usersBySuperior.length - 1)
        result = usersBySuperior[curIndex + 1];
      else result = usersBySuperior[0];
    } else {
      // Previous Action
      if (curIndex > 0) result = usersBySuperior[curIndex - 1];
      else result = usersBySuperior[usersBySuperior.length - 1];
    }
    setSelectedUser(result);
    fetchEmpLeave(result.id);
  };

  const getEmpDetails = (e) => {
    setSelectedUser(e.value);
    fetchEmpLeave(e.value.id);
  };
  
  const TeamDetailsleaveList = () => {
    return (
      <div className="formgrid grid" style={{alignItems: 'center', justifyContent: 'space-between'}}>
        <div className="field pt-2">
          <Button
            type="button"
            label="Previous User"
            className="p-button-rounded p-button-secondary"
            icon="pi pi-angle-left"
          onClick={() => changeUser(-1)}
          />
        </div>

        <div className="field">
        <Dropdown
            value={selectedUser}
            options={usersBySuperior}
            onChange={(e) => getEmpDetails(e)}
            optionLabel="name"
            className="user-options"
            placeholder="Select a User"
            style={{ width: "320px" }}
            filter
            itemTemplate={userOptionTemplate}
            valueTemplate={selectedUserTemplate}
          />
        </div>

        <div className="field pt-2">
          <Button
            label="Next User"
            className="p-button-rounded"
            icon="pi pi-angle-right"
            iconPos="right"
            onClick={() => changeUser(1)}
          />
        </div>
      </div>
    );
  };
  return (
    <div>
      <h1>Team Members</h1>
      <TeamDetailsleaveList />
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            value={emExpensesList}
            resizableColumns
            columnResizeMode="fit"
            scrollable="horizontal"
            stripedRows
          >
            <Column selectionMode="multiple" headerStyle={{ width: "8rem" }} exportable={false} ></Column>
            <Column field="startDate" header="Date" style={{ minWidth: '1rem' }} />
            <Column field="endDate" header="Subject" style={{ minWidth: '1rem' }} />
            <Column field="absenceCode" header="Amount" style={{ minWidth: '1rem' }} />
            <Column field="leaveType" header="Description" style={{ minWidth: '1rem' }} />
            <Column field="reasonOfLeave" header="Status" style={{ minWidth: '1rem' }} />
            <Column field="Status" header="Action" style={{ minWidth: '1rem' }} />
          </DataTable>
      </div>
    );

}
export default ExpensesReview